import { cva } from 'class-variance-authority';

const autocompleteBaseStyles = [
  'absolute',
  'max-h-48',
  'right-0',
  'top-full',
  'border',
  'border-t-0',
  'shadow-md',
  'z-50',
  'w-full',
  'overflow-y-auto',
];

const autocompleteStylesSAG = cva([
  ...autocompleteBaseStyles,
  'bg-[#D1FFF2]',
  'border-[#005159]',

  'dark:bg-[#001F39]',
  'dark:border-[#00FFB9]',
]);

const autocompleteStylesSHS = cva([
  ...autocompleteBaseStyles,
  'bg-white',
  'border-0',
  'dark:bg-[#333333]',
]);

export { autocompleteStylesSAG, autocompleteStylesSHS };
